import { render, staticRenderFns } from "./StudentsPage.vue?vue&type=template&id=048238d5&scoped=true&"
import script from "./StudentsPage.vue?vue&type=script&lang=ts&"
export * from "./StudentsPage.vue?vue&type=script&lang=ts&"
import style0 from "./StudentsPage.vue?vue&type=style&index=0&id=048238d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048238d5",
  null
  
)

export default component.exports